import baseStyles from './Login.module.css';
import styles from './LoginSsoFirst.module.css';
import { useAuth } from '../providers/AuthContext';
import LegacyLoginWidget from './Login';
import EmailAuthLoginSection from './EmailAuthLoginSection';

function LoginSsoFirst({ alwaysOpen, title, buttonClassName, cilogonProvider, onUseLegacy }) {
    const { user } = useAuth();

    // If already authenticated, the legacy widget's logged-in panel is already correct and complete.
    if (user?._id) {
        return <LegacyLoginWidget alwaysOpen={alwaysOpen} title={title} buttonClassName={buttonClassName} />;
    }

    // Safety: selector should only render this when CILogon exists, but keep a hard fallback.
    if (!cilogonProvider?.url) {
        return <LegacyLoginWidget alwaysOpen={alwaysOpen} title={title} buttonClassName={buttonClassName} />;
    }

    if (!alwaysOpen) {
        // For dropdown/topbar mode, we delegate to the legacy widget for the outer trigger + dropdown mechanics.
        // The selector wrapper will only use this component for alwaysOpen gates and dedicated login page.
        return <LegacyLoginWidget alwaysOpen={alwaysOpen} title={title} buttonClassName={buttonClassName} />;
    }

    return (
        <div className={baseStyles.alwaysOpenCard}>
            <h3>{title || 'Sign in'}</h3>
            <p className={styles.primaryText}>
                Use your institution’s credentials to access this site via single sign-on.
            </p>

            <a className={styles.primaryButton} href={cilogonProvider.url}>
                Institutional Login via {cilogonProvider.name || 'CILogon'}
            </a>

            <div className={styles.secondaryRow}>
                <button type="button" className={styles.secondaryLink} onClick={onUseLegacy}>
                    Log in another way
                </button>
            </div>

            <EmailAuthLoginSection variant="ssoFirst" />
        </div>
    );
}

export default LoginSsoFirst;

